import React, { useEffect } from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';
import MetaQueryFieldComponent from './MetaQueryFieldComponent';
import useMetaQueryFieldGroup from './useMetaQueryFieldGroup';

const useStyles = buildUseStyles('MetaQueryFieldGroup', (theme) => ({
  root: {
    display: 'flex',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    alignItems: 'center',
    flexDirection: ({ isMobile }) => (isMobile ? 'column' : 'row'),
  },
}));


export default function MetaQueryFieldGroup({
  resource, metaQueryName, metaQueryOverride, onNewLink, onValueChange, test,
}) {
  const isMobile = useMobileLayout();
  const classes = useStyles({ isMobile });

  const {
    fields, metaQueryValues, setMetaQueryValue, updatedResourceLinkURL, isDifferent, buildUpdatedResourceLink,
  } = useMetaQueryFieldGroup({ resource, metaQueryName, metaQueryOverride });

  useEffect(() => {
    if (!isDifferent) return;

    onNewLink(buildUpdatedResourceLink());
  }, [updatedResourceLinkURL]);

  function handleFieldValueChange(field, value) {
    if (onValueChange) {
      onValueChange(metaQueryValues, field, value);
    }

    if (value === '') {
      setMetaQueryValue(field.attr('name'), null);
      return;
    }
    setMetaQueryValue(field.attr('name'), value);
  }

  return (
    <>
      <Box className={classes.root} test={test} data-test={test}>
        {fields.map(field => (<MetaQueryFieldComponent
          key={field.attr('name')}
          metaQueryField={field}
          value={metaQueryValues[field.attr('name')]}
          onChange={(value) => handleFieldValueChange(field, value)}
        />))}
      </Box>
    </>
  );
}
